import { AbstractStore, ActionHandlers, BaseStoreAction } from './abstract.store';

export interface Presence {
    user: number;
    online: boolean;
}

export type UserStatusStoreState = {
    [userId: number]: boolean;
};

export class ChatUserStatusStore extends AbstractStore<BaseStoreAction, UserStatusStoreState> {
    static $inject = [];
    constructor() {
        super();
    }

    createInitialState(): UserStatusStoreState {
        return {};
    }

    getActionHandlers(): ActionHandlers<BaseStoreAction, UserStatusStoreState> {
        return {
            presence_changed: (state, payload) => {
                return {
                    ...state,
                    [payload.user]: payload.online,
                };
            },
        };
    }

    dispatchPresenceChanged(presence: Presence) {
        this.dispatch({ type: 'presence_changed', payload: presence });
    }

    getPresence$(userId: number) {
        return this.store$.map((s) => s[userId]);
    }
}

angular.module('tradersyard').service('ChatUserStatusStore', ChatUserStatusStore);
